var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23814 11.798L14.7435 6.45143C15.0855 6.11954 15.0855 5.58102 14.7435 5.24913C14.4014 4.91696 13.8475 4.91696 13.5055 5.24913L8.00015 10.5957L2.49453 5.24913C2.15249 4.91696 1.59857 4.91696 1.25653 5.24913C0.91449 5.58102 0.91449 6.11954 1.25653 6.45143L6.76215 11.798L7.30354 12.3236C7.69155 12.7004 8.30875 12.7004 8.69675 12.3236L9.23814 11.798Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownWhiteArrow);
export default __webpack_public_path__ + "static/media/ic_down_white_arrow.d1005230a812cbeda02cd60b6f8a3c27.svg";
export { ForwardRef as ReactComponent };